import {WebSvg} from '@/assets';
import {Button} from '@/components/common';
import {Link} from 'react-router-dom';

const SomeThingWentWrong = ({to}: {to: string}) => {
  return (
    <div className="w-100 ">
      <div className="d-flex justify-content-center align-items-center my-5 flex-column page-not-found-part">
        <img src={WebSvg.AlertIcon} />
        <h1 className="mt-3">Something went wrong</h1>
        <span className="mt-2">It seems like something went wrong.</span>
        <span>Please try again or contact support</span>
        <Link className="mt-4" to={to}>
          <Button>Go to Home</Button>
        </Link>
        <Button onClick={() => window.location.reload()} className="mt-4">
          Refresh the page
        </Button>
      </div>
    </div>
  );
};

export default SomeThingWentWrong;
